"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAmbassadorJWT = void 0;
exports.getAmbassadorJWT = async ({ client, getTokenRequest, }) => await client.getToken(getTokenRequest);
//# sourceMappingURL=get-ambassador-jwt.js.map